export const PATCH_LIST = 'PATCH_LIST';
export const PATCH_LIST_SUCCESS = 'PATCH_LIST_SUCCESS';
export const PATCH_LIST_ERROR = 'PATCH_LIST_ERROR';

export const PATCH_DETAILS = 'PATCH_DETAILS';

export const PATCH_INSPECTION_LIST = 'PATCH_INSPECTION_LIST';
export const PATCH_INSPECTION_LIST_SUCCESS = 'PATCH_INSPECTION_LIST_SUCCESS';
export const PATCH_INSPECTION_LIST_ERROR = 'PATCH_INSPECTION_LIST_ERROR';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';

export const USER_TYPES_LIST = 'USER_TYPES_LIST';
export const USER_TYPES_LIST_SUCCESS = 'USER_TYPES_LIST_SUCCESS';
export const USER_TYPES_LIST_ERROR = 'USER_TYPES_LIST_ERROR';